import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Transactions failed to load',
  description:
    'Couldn’t fetch your transactions. Make sure you’re connected to the internet and try again.',
  tryAgain: 'Try Again',
})
